/**
 * Dummy data — 유저 프로필 (Users)
 * API_DOCS: 2. 유저 (Users)
 */

const delay = (ms) => new Promise((r) => setTimeout(r, ms));

const dummyUser = {
  id: 1,
  name: localStorage.getItem('userName') || '홍길동',
  email: localStorage.getItem('userEmail') || 'hong@email.com',
  phone: '010-1234-5678',
  role: localStorage.getItem('userRole') || 'USER',
  created_at: '2026-01-15T09:00:00',
  social_provider: null,
  language: 'ko',
};

/** GET /api/users/me */
export const getProfile = async () => {
  await delay(200);
  return { ...dummyUser, name: localStorage.getItem('userName') || '홍길동', email: localStorage.getItem('userEmail') || 'hong@email.com' };
};

/** PUT /api/users/me */
export const updateProfile = async (data) => {
  await delay(300);
  Object.assign(dummyUser, data);
  if (data.name) localStorage.setItem('userName', data.name);
  if (data.email) localStorage.setItem('userEmail', data.email);
  return dummyUser;
};

/** PUT /api/users/me/password */
export const changePassword = async () => {
  await delay(300);
  return { message: '비밀번호가 변경되었습니다.' };
};

/** DELETE /api/users/me */
export const deleteAccount = async () => {
  await delay(300);
  localStorage.removeItem('accessToken');
  localStorage.removeItem('userName');
  localStorage.removeItem('userEmail');
  localStorage.removeItem('userRole');
  return { message: '계정이 삭제되었습니다.' };
};

/** GET /api/users/me/reviews */
export const getMyReviews = async () => {
  await delay(200);
  return [
    { id: 1, service_type: 'airport', service: '프라이빗 이동', title: '프라이빗 이동 - 공항 이동', rating: 5, content: '정말 최고의 서비스였습니다.', text: '정말 최고의 서비스였습니다.', created_at: '2026-03-10', reservationNo: 'VVT-2026031001', usageDate: '2026.03.08 14:00', service_label: '프라이빗 이동 - 공항 이동' },
    { id: 2, service_type: 'golf', service: '프라이빗 이동', title: '프라이빗 이동 - 골프 이동', rating: 4, content: '편안하고 깨끗한 차량이었습니다.', text: '편안하고 깨끗한 차량이었습니다.', created_at: '2026-03-08', reservationNo: 'VVT-2026030801', usageDate: '2026.03.06 08:00', service_label: '프라이빗 이동 - 골프 이동' },
  ];
};

/** GET /api/users/me/waitlist */
export const getMyWaitlist = async () => {
  await delay(200);
  return [];
};
